<template>
  <b-dropdown
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    :toggle-class="'rounded-pill dropdown-field text-truncate text-medium ' + toggleClass"
    no-caret
  >
    <template slot="button-content">
      <div class="d-flex align-items-center">
        <span v-if="label" class="mr-2">{{ label }}:</span>
        <span class="text-truncate bold">{{
          selectedOption.fieldLabel || selectedOption.label
        }}</span>
      </div>
    </template>
    <b-dropdown-item
      :active="selected === option.id"
      v-for="(option, index) in options"
      :key="index"
      @click="$emit('change', option)"
    >
      {{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import * as R from 'ramda'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This is the dropdown selector. Selected field is shown as a pill
 * If no item is selected, first option is considered as selected
 *
 */
export default {
  name: 'PillDropdown',
  components: {
    BDropdown,
    BDropdownItem
  },
  props: {
    /**
     *  dropdown options. It should be array of object ({id, label, fieldLabel})
     *  fieldLabel is selected value that is shown to the user. This is optional and fallbacks to label.
     */
    options: Array,
    /**
     * id of selected option
     */
    selected: [String, Number],
    label: String,
    toggleClass: String
  },
  computed: {
    selectedOption() {
      if (this.selected) {
        const sel = this.options.find(R.propEq('id', this.selected))
        return sel || this.options[0]
      } else {
        return this.options[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .dropdown-field {
  overflow: hidden;
  width: 100%;
  border-radius: 15px;
  padding: 1px 12px;

  &:hover,
  &:focus,
  &[aria-expanded='true'] {
    box-shadow: none;
    background-color: $quinary;
  }
}
</style>
